<div class="container-fluid h-100" style="overflow: scroll;">
  <div class="mt-3 mx-1 row">
    <button class="q-btn q-main mr-5" (click)="OnSave()"><i class="fas fa-save"></i></button>
    <label class="mb-0 mr-2" style="align-self: center;">Nombre d'onglets par ligne :</label>
    <input *ngIf="model" type="text" [(ngModel)]="model.rank" class="q-input-border mb-0" />
  </div>
  <table *ngIf="model?.Items" class="mx-1 table table-bordered table-striped mt-3">
    <thead class="q-light-secondary">
      <tr>
        <th class="" style="width: 70px;">Ordre</th>
        <th class="">Libellé par dédaut</th>
        <th class="">Libellé personnalisé</th>
        <th style=" width: 100px;">
          <div class="q-check">
            <input type="checkbox" id="checkAllGrille" [ngModel]="AllChecked('isPreview')" (click)="OnCheckAll('isPreview')" />
            <label for="checkAllGrille">
              <span></span>Grille
            </label>
          </div>
        </th>
        <th style="width: 101px;">
          <div class="q-check">
            <input type="checkbox" id="checkAllAjout" [ngModel]="AllChecked('showCreateButton')" (click)="OnCheckAll('showCreateButton')" />
            <label for="checkAllAjout">
              <span></span>Ajout.
            </label>
          </div>
        </th>
        <th style=" width: 103px;">
          <div class="q-check">
            <input type="checkbox" id="checkAllModif" [ngModel]="AllChecked('showSaveButton')" (click)="OnCheckAll('showSaveButton')" />
            <label for="checkAllModif">
              <span></span>Modif.
            </label>
          </div>
        </th>
        <th style=" width: 104px;">
          <div class="q-check">
            <input type="checkbox" id="checkAllSuppr" [ngModel]="AllChecked('showRemoveButton')" (click)="OnCheckAll('showRemoveButton')" />
            <label for="checkAllSuppr">
              <span></span>Suppr.
            </label>
          </div>
        </th>
        <th style=" width: 102px;">
          <div class="q-check">
            <input type="checkbox" id="checkAllOuvrir" [ngModel]="AllChecked('OpenContext')" (click)="OnCheckAll('OpenContext')" />
            <label for="checkAllOuvrir">
              <span></span>Ouvrir
            </label>
          </div>
        </th>
        <th style=" width: 100px;">
          <div class="q-check">
            <input type="checkbox" id="checkAllRech" [ngModel]="AllChecked('showImportButton')" (click)="OnCheckAll('showImportButton')" />
            <label for="checkAllRech">
              <span></span>Rech.
            </label>
          </div>
        </th>
        <th class="">Trier sur</th>
        <th class="">Sens</th>
        <th class="">Filtre</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of model.Items; let i = index">
        <tr>
          <td class="p-1" style="width: 70px;">
            <input style="width: 70px;" type="number" class="h-100 w-100 pl-3 q-input-no-border"
                   [ngModel]="item.order" (ngModelChange)="ValueStringified(item, 'order', $event)"
                   (blur)="CheckGrille(item)"
                   min="1" />
          </td>
          <td class="py-0">{{item.defaultTitle}}</td>
          <td class="p-1"><input type="text" class="h-100 w-100 pl-3 q-input-no-border" [(ngModel)]="item.title" /></td>
          <td class="py-0" style=" width: 100px;">
            <div class="q-check">
              <input type="checkbox" id="Grille_{{i}}" [(ngModel)]="item.isPreview" />
              <label for="Grille_{{i}}" class="d-flex justify-content-center align-items-center m-0">
                <span></span>
              </label>
            </div>
          </td>
          <td class="py-0" style=" width: 101px;">
            <div class="q-check">
              <input type="checkbox" id="Ajout_{{i}}" [(ngModel)]="item.showCreateButton" />
              <label for="Ajout_{{i}}" class="d-flex justify-content-center align-items-center m-0">
                <span></span>
              </label>
            </div>
          </td>
          <td class="py-0" style=" width: 103px;">
            <div class="q-check">
              <input type="checkbox" id="Modif_{{i}}" [(ngModel)]="item.showSaveButton" />
              <label for="Modif_{{i}}" class="d-flex justify-content-center align-items-center m-0">
                <span></span>
              </label>
            </div>
          </td>
          <td class="py-0" style=" width: 104px;">
            <div class="q-check">
              <input type="checkbox" id="Suppr_{{i}}" [(ngModel)]="item.showRemoveButton" />
              <label for="Suppr_{{i}}" class="d-flex justify-content-center align-items-center m-0">
                <span></span>
              </label>
            </div>
          </td>
          <td class="py-0" style=" width: 102px;">
            <div class="q-check">
              <input type="checkbox" id="Ouvrir_{{i}}" [(ngModel)]="item.OpenContext" />
              <label for="Ouvrir_{{i}}" class="d-flex justify-content-center align-items-center m-0">
                <span></span>
              </label>
            </div>
          </td>
          <td class="py-0" style=" width: 100px;">
            <div class="q-check">
              <input type="checkbox" id="Rech_{{i}}" [(ngModel)]="item.showImportButton" />
              <label for="Rech_{{i}}" class="d-flex justify-content-center align-items-center m-0">
                <span></span>
              </label>
            </div>
          </td>
          <td class="p-1">
            <select *ngIf="item?.tableColumns" class="q-main-select w-100" [(ngModel)]="item.sort">
              <option *ngFor="let option of item.tableColumns" [value]="option.Value">{{option.Text}}</option>
            </select>
          </td>
          <td class="p-1">
            <select class="q-main-select w-100" [(ngModel)]="item.sortDirection">
              <option value="">-----</option>
              <option value="ASC">Croissant</option>
              <option value="DESC">Décroissant</option>
            </select>
          </td>
          <td class="p-1"><input type="text" class="h-100 w-100 pl-3 q-input-no-border" [(ngModel)]="item.completeWhere" /></td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
